import { Box, Typography } from '@mui/material'

import GoogleIcon from '../icon/GoogleIcon'

export default function UserHeaderCard({ icon, filled = false, label, value }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.6,
        minWidth: 0,
        maxWidth: '100%'
      }}
    >
      <GoogleIcon name={icon} size={18} filled={filled} color="#515465" />

      {label && (
        <Typography
          component="span"
          sx={{
            fontSize: 12,
            color: '#50739A',
            fontWeight: 600,
            lineHeight: 1.2,
            whiteSpace: 'nowrap'
          }}
        >
          {label}
        </Typography>
      )}

      <Typography
        component="span"
        sx={{
          fontSize: 12,
          color: '#50739A',
          fontWeight: 600,
          lineHeight: 1.2,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {value}
      </Typography>
    </Box>
  )
}
